// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__3FgI_","formSpace":"styles_formSpace__J4zvd"};